export { determineAssetColor } from './colors';

export function titleCase(str: string) {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ');
}

export function hexToRgb(hex: string, alpha?: number) {
  hex = hex.replace(/^#/, '');

  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  const a = alpha ?? 1;

  return { r, g, b, a };
}

export function transformString(str: string): string {
  return str
    .split('-') // Split the string into an array of words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the words with a space
}

// The points dashboard is served on both `.spark.fi` and `.spark.finance` hosts;
// outbound links to Spark-owned domains should follow whichever TLD the user is on
// rather than hardcoding `.spark.fi`. Unknown hosts (Vercel previews, localhost)
// fall back to `.fi`. See office#379.
export function currentSparkTld(): 'fi' | 'finance' {
  if (typeof window === 'undefined') return 'fi';
  const host = window.location.hostname;
  return host === 'spark.finance' || host.endsWith('.spark.finance')
    ? 'finance'
    : 'fi';
}

// Rewrites the TLD of any Spark-owned URL (`spark.fi` / `spark.finance`, with or
// without a subdomain) to match the current host. Other domains and the `sparkdotfi`
// social handles are left untouched.
export function sparkUrl(url: string): string {
  return url.replace(/spark\.(fi|finance)\b/g, `spark.${currentSparkTld()}`);
}

// Season 5 goes live the second after Season 4's final reward tick
// (S4 ends 2026-08-12T13:59:59Z). The Z-suffixed ISO string parses as UTC in
// every engine, so the comparison against Date.now() (also UTC epoch millis)
// is independent of the viewer's timezone/DST. Both the leaderboard URL and
// the header title derive from this one switch. See office#884.
const SEASON_5_START_MS = Date.parse('2026-08-12T14:00:00Z');

export function currentSeason(): 4 | 5 {
  return Date.now() >= SEASON_5_START_MS ? 5 : 4;
}
